import BannerWarning from "./warning";
export default {
  Warning: BannerWarning
}